<template>
    <div class="quiz">
        <TextBox
            v-bind="textBox"
        >
            <slot name="question" />
        </TextBox>
        <SlideInTransition
            v-bind="slideInConfig"
            @complete="activate"
        >
            <ul
                class="styleless answers"
                :class="{answered, active, 'as-buttons': answersAsButton}"
            >
                <li
                    v-for="(answer, i) in answers"
                    :key="i"
                    :class="answer"
                    class="answer"
                    @click="selectAnswer(i)"
                >
                    <slot :name="`answer${i}`">
                        {{ defaultAnswers[i] }}
                    </slot>
                </li>
            </ul>
        </SlideInTransition>
    </div>
</template>

<script>
import SlideState from '@/mixins/SlideState';

export default {
    name: 'Quiz',
    mixins: [SlideState],
    props: {
        correctAnswer: {
            type: Number,
            required: true
        },
        slideInAnswersFrom: {
            type: String,
            required: true
        },
        textBox: {
            type: Object,
            required: true
        },
        answersCount: {
            type: Number,
            default: 3
        },
        answersAsButton: {
            type: Boolean,
            default: false
        }
    },
    data()
    {
        const answers = [];
        for (let i = 0; i < this.answersCount; i++)
        {
            answers.push({
                selected: false,
                correct: false,
                incorrect: false
            });
        }
        return {answers, answered: false, active: false};
    },
    computed: {
        slideInConfig()
        {
            const config = {};
            const hasState = this.hasState();

            if (hasState)
            {
                config.tweenDuration = 0.4;
                config.from = '';
                config.stagger = 0;
                config.delay = 0.2;
                config.ease = 'power1.out';
            }
            else
            {
                config.tweenDuration = this.answersAsButton ? 0.4 : undefined;
                config.from = this.slideInAnswersFrom;
                config.delay = 0.5;
            }

            return config;
        },
        defaultAnswers()
        {
            const answers = [];
            if (this.answersAsButton && this.answersCount === 2)
            {
                answers.push('Ja', 'Nein');
            }
            return answers;
        }
    },
    mounted()
    {
        const state = this.getState();
        if (state !== null)
        {
            this.selectAnswer(state, false);
        }
    },
    methods: {
        activate()
        {
            if (!this.hasState())
            {
                this.active = true;
            }
        },
        selectAnswer(index, onClick = true)
        {
            const {answers, correctAnswer} = this;
            const correct = correctAnswer === index;
            answers[index].selected = true;
            answers[correctAnswer].correct = true;
            if (!correct)
            {
                answers[index].incorrect = true;
            }
            if (onClick)
            {
                this.$audioController.play(correct ? 'positive' : 'negative', {volume: 0.5});
            }
            this.active = false;
            this.answered = true;
            this.$emit('answered', correct);
            this.saveState(index);
        }
    }
};
</script>

<style lang="scss" src="./Quiz.scss" />

